/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.LogisticsChannelResponseDto>>;
export function request(
  params: API.tms.logisticsChannel.getPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
